import { useTranslation } from 'react-i18next';
import { TailSpin } from 'react-loader-spinner';

import { formatEuropeanCurrency } from 'helpers/formatCurrency';

import { Headline } from 'components/Headline';
import { Loader } from 'components/Loader';

import { useHeader } from './Header.hooks';
import * as S from './Header.styles';

export function Header(): React.ReactElement {
  const { isLoading, data, isQuantityUpdating } = useHeader();
  const { t } = useTranslation();

  const renderLoader = () => (
    <div style={{ display: 'inline-block', marginLeft: '10px', verticalAlign: 'middle' }}>
      <TailSpin height="15" width="15" color="grey" ariaLabel="loading" />
    </div>
  );

  return (
    <Loader isLoading={isLoading && !data}>
      <S.Container>
        <S.Wrapper>
          {data?.prevSeasonBilling ? (
            <Headline
              scale="s"
              textTransform="uppercase"
              fontWeight="extraLight"
              fontFamily="LFT Zeno"
            >
              {t('budget.prevSeasonBilling')} :{' '}
              {formatEuropeanCurrency(data?.prevSeasonBilling, data?.prevCurrency || 'EUR')}
            </Headline>
          ) : null}

          {data?.prevSeasonSells ? (
            <Headline
              scale="s"
              textTransform="uppercase"
              fontWeight="extraLight"
              fontFamily="LFT Zeno"
            >
              {t('budget.prevSeasonSells')} : {data?.prevSeasonSells}
            </Headline>
          ) : null}

          {/* <S.InputWrapper>
            <Headline
              scale="s"
              textTransform="uppercase"
              fontWeight="extraLight"
              fontFamily="LFT Zeno"
            >
              {t('budget.estimateInsert')} :
            </Headline>

            <S.EstInput register={register} name="insert" motive="orderCell" />
          </S.InputWrapper> */}
        </S.Wrapper>

        <S.Wrapper>
          {data?.currBudget ? (
            <Headline
              scale="s"
              textTransform="uppercase"
              fontWeight="extraLight"
              fontFamily="LFT Zeno"
            >
              {t('budget.currBudget')} :{' '}
              {formatEuropeanCurrency(data?.currBudget, data?.currCurrency || 'EUR')}
              {isQuantityUpdating && renderLoader()}
            </Headline>
          ) : null}

          {data?.currBudgetQty ? (
            <Headline
              scale="s"
              textTransform="uppercase"
              fontWeight="extraLight"
              fontFamily="LFT Zeno"
            >
              {t('budget.currBudgetQty')} : {data?.currBudgetQty}
              {isQuantityUpdating && renderLoader()}
            </Headline>
          ) : null}
        </S.Wrapper>
      </S.Container>
    </Loader>
  );
}
